<template>
	<div>
		<myheader headTitle="成员信息"></myheader>
		<div class="header_extend_main">
			<div class="header_extend_back"></div>
			<div class="header_extend_content">
				<div class="all_tips_content_card">
					<div style="margin: .5rem auto .2rem;" class="all_text_center">
						<img style="width: 3rem; height: 3rem; " src="@/assets/images/memberedit.svg">
						<div class="text14 textcolor333 margin_top_3 ">
							<span class="font_weight_bold">{{memberInfo.staffName}}</span>
							<span style="margin-left: 2rem;">{{memberInfo.genderText}}</span>
						</div>
						<div class="display_flex text14 textcolor333 margin_top_5 font_weight_bold"
							style="justify-self: center;justify-content: center;align-self: center;align-items: center;">
							<span class="font_weight_bold">{{memberInfo.userName}}</span>
							<img v-if="memberInfo.staffStatus === 2" src="@/assets/images/memberstatus.png"
								style="margin-left: 1rem;width: 1.2rem;height: 1.2rem;object-fit: fill;" />
							<span
								style="margin-left: .2rem;padding: .2rem .3rem;border-radius: .2rem;background-color: #d7d7d7;"
								class="text10 textcolor666">{{memberInfo.staffStatusText}}</span>
						</div>
						<!-- <div v-if="memberInfo.isCertified" class="text12 textcolor666 passed"
							style="position: absolute;bottom: 1rem;right: .5rem;padding: .1rem .3rem;">
							已认证
						</div> -->
					</div>
				</div>
			</div>
			<div class="margin_top_10 backgroundC_white">
				<!-- <div style="padding: 0 .8rem;">
					<span class="text14 textcolor333 all_line_height24"
						style="display: inline-block;width: 20%;">手机号</span>
					<span class="text14 textcolor333 all_line_height24"
						style="display: inline-block;width: 80%;text-align: right;">{{memberInfo.mobile}}</span>
					<span></span>
				</div>
				<div style="padding: 0 .8rem;">
					<span class="text14 textcolor333 all_line_height24"
						style="display: inline-block;width: 20%;">电子邮箱</span>
					<span class="text14 textcolor333 all_line_height24"
						style="display: inline-block;width: 80%;text-align: right;">{{memberInfo.email}}</span>
				</div> -->
				<div class="flex" style="padding: 0 .8rem;">
					<span class="text14 textcolor333 all_line_height24"
						style="display: inline-block;width: 20%;">企业</span>
					<span class="text14 textcolor333 all_line_height24"
						style="display: inline-block;width: 80%;text-align: right;">{{corpName}}</span>
					<!-- <img src="../../assets/images/u359.png" style="height: .8rem;margin: .8rem 0 .8rem 1rem;"> -->
				</div>
				<div class="flex" style="padding: 0 .8rem;" @click="showCanChange()">
					<span class="text14 textcolor333 all_line_height24"
						style="display: inline-block;width: 20%;">权限</span>
					<span class="text14 textcolor333 all_line_height24"
						style="display: inline-block;width: 80%;text-align: right;">{{(memberInfo.isSigner?'签名人 ':'')+(memberInfo.isSealer?'盖章人':'')}}</span>
					<!-- <img src="../../assets/images/u359.png" style="height: .8rem;margin: .8rem 0 .8rem 1rem;"> -->
				</div>
			</div>
			<div v-if="canAdmin === 'true'"
				class="all_height_line24 all_text_center text14 backgroundC_white bwhite_ative"
				style="color: #FF0000;margin-top: 2rem;" @click="removeClick()">移除成员</div>
		</div>
		<van-popup v-model:show="showBottom" :overlay="true" position="bottom">
			<div>
				<div style="margin: .5rem .8rem;" class="text16 textcolor333">设置用户权限</div>
				<div class="horizontal_line"></div>
				<div style="margin: 1rem .8rem;"><van-checkbox class="text14 textcolor333"
						v-model="memberInfo.isSigner">签名人</van-checkbox></div>
				<div class="horizontal_line"></div>
				<div style="margin: 1rem .8rem;"><van-checkbox class="text14 textcolor333"
						v-model="memberInfo.isSealer">盖章人</van-checkbox></div>
				<div class="horizontal_line"></div>
				<div>
					<button style="width: 40%;margin: 5%;" class="all_button20 text16 backgroundC_ccc bwhite_ative"
						@click="showBottom = false">取消</button>
					<button style="width: 40%;margin: 5%;" class="all_button20 text16 bmain_active"
						@click="sumbit()">确定</button>
				</div>
			</div>
		</van-popup>
	</div>
</template>

<script>
	import {
		Dialog
	} from 'vant'
	import {
		Checkbox,
	} from "vant";
	export default {
		components: {
			[Checkbox.name]: Checkbox,
		},
		data() {
			return {
				//企业id
				//corpId: '',
				//企业id
				corpName: '',
				//
				canAdmin: '',
				//成员id
				//staffId: '',
				//
				staffCorpId: '',
				//企业信息
				memberInfo: '',
				//
				isSigner: false,
				//
				isSealer: false,
				//
				showBottom: false,
			}
		},
		methods: {
			//确定
			sumbit() {
				let data = {
					isSealer: this.isSealer,
					isSigner: this.isSigner,
					staffCorpId: this.staffCorpId
				}
				this.saveJoinMember(data)
			},
			//
			showCanChange() {
				if (this.canAdmin === 'true') {
					this.showBottom = true
				}
			},
			//修改成员权限
			saveJoinMember(data) {
				this.$store.dispatch(this.$LoadShow, true)
				this.$post('/corp/m/api/saveJoinMember', data).then(res => {
					this.$store.dispatch(this.$LoadShow, false)
					if (res.success) {
						this.$Toast('修改成功！')
					} else {
						this.isSealer = this.memberInfo.isSealer
						this.isSigner = this.memberInfo.isSigner
						this.$Toast(res.message || res.messageDetail || '修改成员权限失败！')
					}
				}).catch(err => {
					this.isSealer = this.memberInfo.isSealer
					this.isSigner = this.memberInfo.isSigner
					this.$store.dispatch(this.$LoadShow, false)
					this.$Toast('修改成员权限失败！')
					console.log('saveJoinMember', err)
				})
			},
			//移除弹窗
			removeClick() {
				Dialog.confirm({
						title: '提示',
						message: '确定移除该成员？',
						confirmButtonText: '确定',
						confirmButtonColor: '#0277FC'
					})
					.then(() => {
						this.removeMember()
					})
			},
			//移除成员
			removeMember() {
				this.$store.dispatch(this.$LoadShow, true)
				this.$get('/corp/m/api/removeStaffCorp', {
					id: this.memberInfo.staffCorpId
				}).then((res) => {
					this.$store.dispatch(this.$LoadShow, false)
					if (res.success) {
						this.$Toast('成功移除成员！')
						this.$router.go(-1)
					} else {
						Dialog.alert({
							title: '提示',
							message: res.message,
							confirmButtonText: '关闭',
							confirmButtonColor: '#0277FC'
						}).then(() => {});
					}
				}).catch(err => {
					this.$store.dispatch(this.$LoadShow, false)
					this.$Toast('移除成员失败，请重试！')
					console.log('removeStaffCorp', err)
				})
			},
			//获取成员信息
			getMemberInfo() {
				this.$store.dispatch(this.$LoadShow, true)
				this.$get('/corp/m/api/getMemberInfo', {
					id: this.staffCorpId
				}).then((res) => {
					this.$store.dispatch(this.$LoadShow, false)
					if (res.success && res.data) {
						this.isSealer = res.data.isSealer
						this.isSigner = res.data.isSigner
						this.memberInfo = res.data
						if(this.memberInfo.staffId === this.$store.state.userInfo.staffId){
							this.canAdmin = 'false'
						}
					} else {
						this.$Toast(res.message || res.messageDetail || '获取成员信息失败！')
					}
				}).catch(err => {
					this.$store.dispatch(this.$LoadShow, false)
					this.$Toast('获取成员信息失败！')
					console.log('getMemberInfo', err)
				})
			},
			//初始化
			init() {
				//this.corpId = this.$route.query.corpId
				this.corpName = this.$route.query.corpName
				//this.staffId = this.$route.query.staffId
				this.staffCorpId = this.$route.query.staffCorpId
				this.canAdmin = this.$route.query.canAdmin
				console.log('canAdmin', this.canAdmin)
				this.getMemberInfo()
			},
		},
		mounted() {
			this.init()
		}
	}
</script>

<style scoped lang="scss">
	@import "../../../styles/global.css";

	.passed {
		color: #66BE74;
		border: 1px solid #66BE74;
	}
</style>